import { z } from 'zod'

export const GetKPIDataQuery = z.object({
  date: z.string().date(),
  orderBook: z.string().nullish(),
  exchangeId: z.string().nullish(),
  daysLookback: z.coerce.number().int().positive().optional(),
})

export type GetKPIDataQueryType = z.infer<typeof GetKPIDataQuery>

export const GetKPIDataResult = z.object({
  activeDex: z.number().safe(),
  activeCex: z.number().safe(),
  avg24hVolume: z.number().safe().nullable(),
  avgDepth: z.number().safe().nullable(),
  spread: z.number().safe().nullable(),
})
